module.exports = "../../../../platform/assets/pageMainIcon/icon-zuzhi-1-green.svg";